// Reading build-time settings safely.
//
// Create React App replaces `process.env.REACT_APP_X` with the variable's value while the
// site is being built. When the variable was never set there is nothing to replace it with,
// so the expression becomes the JavaScript value `undefined` — and dropping that into a
// template string produces the literal text "undefined", which is how the published site
// once ended up requesting addresses like "undefined/api/visits".
//
// Every setting is therefore read through these helpers, which treat a missing, blank or
// literally-"undefined" value as "not configured" rather than as a usable string.

export function envString(value) {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  return trimmed === "" || trimmed === "undefined" || trimmed === "null" ? "" : trimmed;
}

// Only an absolute http(s) address is usable. A relative one would resolve against
// apmercl.com and quietly fetch the site's own index.html, which looks like a success.
export function envUrl(value) {
  const text = envString(value);
  return /^https?:\/\//i.test(text) ? text.replace(/\/+$/, "") : "";
}

// The empty-string check is not redundant: `Number("")` is 0, not NaN, so without it an
// unset variable would read as a deliberate zero and quietly replace the fallback.
export function envNumber(value, fallback) {
  const text = envString(value);
  if (text === "") return fallback;
  const n = Number(text);
  return Number.isFinite(n) && n >= 0 ? Math.floor(n) : fallback;
}
